import React from 'react';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import AccountIcon from 'mdi-react/AccountIcon';

import * as S from './styles';

type OwnProps = {
  className?: string;
  size?: number;
};

type MeProps = {
  displayName?: string | null;
  avatar?: string | null;
  email?: string | null;
};

type Props = OwnProps & MeProps;

const UserAvatar = ({
  size = 32,
  className,
  avatar,
  displayName,
  email,
}: Props) => {
  const isLoggedIn = displayName || email;
  const validNameOrEmail = /^[A-Za-z]/;

  const symbol = () => {
    if (isLoggedIn) {
      if (avatar)
        return (
          <S.Image
            alt={displayName || email || ''}
            src={avatar}
            width={size}
            height={size}
          />
        );

      if (displayName && displayName.match(validNameOrEmail))
        return <span>{displayName.charAt(0)}</span>;

      if (email && email.match(validNameOrEmail))
        return <span>{email.charAt(0)}</span>;

      return <AccountIcon color="currentColor" size={size * 0.75} />;
    }

    return <AccountOutlineIcon color="currentColor" size={size} />;
  };

  return (
    <S.UserAvatar
      className={className}
      data-test="UserAvatar"
      size={size}
      isLoggedIn={Boolean(isLoggedIn)}
      hasAvatar={Boolean(avatar)}
    >
      {symbol()}
    </S.UserAvatar>
  );
};

export default UserAvatar;
